module.exports = __webpack_public_path__ + "static/media/google.1ba97428.svg";